import {
	componentNameConstants,
	dlElementConstants,
	dlEventConstants,
} from "@repo/analytics/data-layer.constants";
import { dataLayer } from "@repo/analytics/data-layer-utils";
import { openRedirectURL } from "@repo/shared-utils/common-utils";
import { IPO_TYPE, currencySymbol } from "./IpoListConstants";
import { IIpoListCard } from "../../interfaces/IpoList.interface";

export const IpoListFunctions = () => {
	const getInfoValue = (ipoDetails: IIpoListCard, ipoType: string, tbaText = "To be announced") => {
		switch (ipoType) {
			case IPO_TYPE.CURRENT:
				return getCurrentIpoInfo(ipoDetails);

			case IPO_TYPE.UPCOMING:
				return getUpcomingIpoInfo(ipoDetails, tbaText);

			case IPO_TYPE.CLOSED:
				return getClosedIpoInfo(ipoDetails);

			default:
				return "-";
		}
	};

	const getCurrentIpoInfo = (ipoDetails: IIpoListCard): string => {
		let result = "-";

		if (ipoDetails?.minInvestmentAmt && !ipoDetails?.minInvestedShares) {
			result = `${currencySymbol}${ipoDetails?.minInvestmentAmt} / - Lot`;
		} else if (!ipoDetails?.minInvestmentAmt && ipoDetails?.minInvestedShares) {
			result = `- / ${ipoDetails?.minInvestedShares} Lot`;
		} else if (ipoDetails?.minInvestmentAmt && ipoDetails?.minInvestedShares) {
			result = `${currencySymbol}${ipoDetails?.minInvestmentAmt} / ${ipoDetails?.minInvestedShares} Lot`;
		}

		return result;
	};


	const getUpcomingIpoInfo = (ipoDetails: IIpoListCard, tbaText: string): string => {
		let result = tbaText;

		if (ipoDetails?.lowLt && !ipoDetails?.uppLt && ipoDetails?.lowLt !== "0") {
			result = `${currencySymbol}${ipoDetails?.lowLt}`;
		} else if (!ipoDetails?.lowLt && ipoDetails?.uppLt && ipoDetails?.uppLt !== "0") {
			result = `${currencySymbol}${ipoDetails?.uppLt}`;
		} else if (
			ipoDetails?.lowLt &&
			ipoDetails?.uppLt &&
			ipoDetails?.uppLt !== "0" &&
			ipoDetails?.lowLt !== "0") {
			result = `${currencySymbol}${ipoDetails?.lowLt} - ${currencySymbol}${ipoDetails?.uppLt}`;
		}

		return result;
	};


	const getClosedIpoInfo = (ipoDetails: IIpoListCard) => {
		return ipoDetails?.listingdayRes && typeof ipoDetails?.listingdayRes === "number"
			? Math.abs(ipoDetails?.listingdayRes ?? 0).toFixed(2)
			: "-";
	};

	const getInfoLabel = (
		ipoType: string,
		minimumInvestmentText: string,
		bidPriceText: string,
		listingGainText: string,
	) => {
		switch (ipoType) {
			case IPO_TYPE.CURRENT:
				return minimumInvestmentText;
			case IPO_TYPE.UPCOMING:
				return bidPriceText;
			case IPO_TYPE.CLOSED:
				return listingGainText;
		}
	};

	const closingText = (closing?: string) => {
		return closing ? `Closing ${closing}` : "";
	};

	const getStockPriceStatus = (ipoItem: IIpoListCard) => {
		return ipoItem?.listingdayRes?.toString().charAt(0) === "-" ? "text-[#b40000]" : "text-[#067161]";
	};

	const getStockStatus = (ipoItem: IIpoListCard) => {
		return ipoItem?.listingdayRes?.toString().charAt(0) === "-"
			? "before:content-['\\e981']"
			: "before:content-['\\e980']";
	};

	const getIpoDateDisplay = (itemDetails: IIpoListCard, ipoType: string, tbaText: string): string => {
		if (ipoType === IPO_TYPE.CLOSED) {
			return itemDetails?.listedDt ?? "-";
		}
		if (ipoType === IPO_TYPE.UPCOMING) {
			return tbaText?.trim() || "To be announced";
		}
		if (itemDetails?.bidStartDt && itemDetails?.bidEndDt) {
			return `${itemDetails.bidStartDt} - ${itemDetails.bidEndDt}`;
		}
		return "-";
	};

	const handleViewAll = (loginStatus: string, redirectURL?: string, openInNewTab?: string, viewAllText?: string, ipoTitle?: string) => {
		const urlTarget = openInNewTab === "true" ? "_blank" : "_self";
		openRedirectURL(redirectURL, urlTarget);
		const dataLayerObj = {
			component: componentNameConstants.IPO_LIST,
			event: dlEventConstants.CLICK,
			section_title: viewAllText,
			cta_text: viewAllText,
		};
		const clevertapObj = {
			EVENT_NAME: dlElementConstants.PLP_CLICKED,
			EP_JOURNEY_NAME: dlElementConstants.TRADING_MALL_IPO_PLP,
			EP_PAGE_NAME: ipoTitle ?? "",
			EP_SECTION: viewAllText ?? "",
			EP_CTA: viewAllText ?? "",
		};
		dataLayer(loginStatus,dataLayerObj, clevertapObj);
	};

	return {
		getInfoValue,
		getInfoLabel,
		getStockPriceStatus,
		getStockStatus,
		getIpoDateDisplay,
		closingText,
		handleViewAll,
	};
};